import { FC } from 'react';
import { Box, Image, Stack, Text } from '@chakra-ui/react';
import { sanitizeHtml } from '../../../../utils';

import { JoinTeamModal } from './JoinTeamModal';
import styles from './JoinTeam.module.scss';
import { JoinTeamImg } from '../../../../assets';

export interface JoinTeamProps {
  headline: string;
  description: string;
  imgPath: string;
}

export const JoinTeam: FC<JoinTeamProps> = ({
  headline,
  description,
  imgPath,
}) => (
  <Box
    borderColor="brand.monochromatic.200"
    borderRadius="8px"
    boxShadow="0 0 2px 0 #00000095"
    w="full"
  >
    <Box className={styles.container}>
      <Image src={imgPath} w="full" fallbackSrc={JoinTeamImg} />
      <Box fontWeight="semibold" fontSize="xl" className={styles.centered}>
        {headline}
      </Box>
    </Box>

    <Stack pt={6} px={5}>
      <Text fontSize="md" color="brand.monochromatic.900" align="left">
        {sanitizeHtml(description)}
      </Text>

      <Box py={6}>
        <JoinTeamModal />
      </Box>
    </Stack>
  </Box>
);
